<template>
	<Row>
		<Container>
			<div class="header-container">
				<h1 class="content-title">
					Our Team of Traders Is Ready To Help You Reach Your Goals
				</h1>
				<p class="text-lg text-slate-100 text-left leading-loose">
					At StocksToTrade we offer a variety of trading mentors with different
					backgrounds and specialties. And they’re all ready to help guide you on
					your unique path to becoming a successful trader!
				</p>
			</div>
			<div
				v-for="(trader, index) in traders"
				:key="index"
				class="trader-authors-container"
			>
				<TeamTraderAuthor
					:name="trader.name"
					:image-src="trader.imageSrc"
					:alt-text="trader.altText"
					:profile-link="trader.profileLink"
					:twitter-link="trader.twitterLink"
					:youtube-link="trader.youtubeLink"
					:paragraphs="trader.paragraphs"
					:additional-content="trader.additionalContent"
				/>
			</div>
		</Container>
	</Row>
</template>
<script>
export default {
	data() {
		return {
			traders: [
				{
					name: "Tim Bohen",
					imageSrc: "/images/trader-section-tim-bohen.webp",
					altText: "Tim Bohen",
					profileLink: "/authors/tim-bohen",
					twitterLink: "https://twitter.com/tbohen",
					youtubeLink: "https://www.youtube.com/@Stockstotrade",
					paragraphs: [
						"Tim Bohen is our lead trainer and everyone’s favorite “trading dad.” He’s had a lifelong interest in finance and the markets.",
						"He started dabbling in trading large-cap names in 2005 but wasn’t having much success.",
						"By 2007/2008 — like most people during that time — he watched his 401k, investments, and rental properties lose value. He knew there had to be a better way to grow wealth through the markets."
					],
					additionalContent: [
						"That’s when he discovered small caps and day trading. He dug into learning everything he could and started off mostly short selling.",
						"By 2013, he was making money consistently enough to trade full time and sell the business he had grown over the prior 15 years.",
						"After noticing that short selling was becoming an overcrowded strategy, Tim started going long to take advantage of rip-your-face-off short squeezes to the upside.",
						"After joining the StocksToTrade team in 2015, he found his true passion for teaching others how to trade conservatively and safely while capturing the same monster moves."
					]
				},
				{
					name: "Matt Monaco",
					imageSrc: "/images/trader-section-matt-monaco.webp",
					altText: "Matt Monaco",
					profileLink: "/authors/matt-monaco",
					twitterLink: "https://twitter.com/mono_trader",
					youtubeLink:
						"https://www.youtube.com/watch?v=U_Vmh4RaVc8&list=PLWWz2BSabm3ZoJuAjeZpiLXD5lGO1v_Yl",
					paragraphs: [
						"Back in 2017, Matt Monaco was in college studying to become a software engineer — and he HATED it. By the time he started doing internships, he knew it wasn’t what he wanted to do with his life.",
						"In 2017, he came across Timothy Sykes online and decided he wanted to become a stock trader.",
						"He joined Tim Sykes’ Trading Challenge and started trading with $25,000 he saved from side hustles while still in college."
					],
					additionalContent: [
						"He started the “Beyond the PDT” podcast with his roommate Bryce Tuohey and started networking with other traders.",
						"After a couple of years of grinding, Matt started to find trading consistency. And by June 2020, he had grown his $25,000 account into $100,000.",
						"Matt has since grown his account to almost $2 million. And he proves that hard work and perseverance pay off.",
						"He credits his success to having a supportive trading mentor and community. Now he pays it forward helping others take their trading to new heights in our Small Cap Rockets chat room."
					]
				},
				{
					name: "Bryce Tuohey",
					imageSrc: "/images/trader-section-bryce-tuohey.webp",
					altText: "Bryce Tuohey",
					profileLink: "/authors/bryce-tuohey",
					twitterLink: "https://twitter.com/TraderBryce",
					youtubeLink:
						"https://www.youtube.com/watch?v=U_Vmh4RaVc8&list=PLWWz2BSabm3ZoJuAjeZpiLXD5lGO1v_Yl",
					paragraphs: [
						"Bryce Tuohey was Matt Monaco’s college roommate. He started trading around the same time as Matt.",
						"However, Bryce admits he wasn’t taking it seriously enough in the beginning ... But when he saw Matt make $1,000+ in a single trade — he knew he had to buckle down.",
						"He started trading with a tiny position size in one specific setup. And he cut his max risk per trade to a minuscule amount until he gained consistency. Then he scaled up…"
					],
					additionalContent: [
						"And his growth has been exponential ever since!",
						"Bryce has now reached the ultimate goal of $1 million in trading profits. He helps others reach their trading goals in the Small Cap Rockets chat room!"
					]
				}
			]
		};
	}
};
</script>
<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

.header-container {
	align-items: center;
	text-align: center;
	margin-bottom: 24px;

	.content-title {
		font-family: Open Sauce Sans;
		font-size: 36px;
		font-weight: 500;
		line-height: 59px;
		letter-spacing: -0.02em;
		text-align: center;
		margin-bottom: 24px;
		background: linear-gradient(
			90deg,
			rgb(255, 255, 255) 25%,
			rgb(67, 131, 255) 60%,
			rgb(196, 100, 255) 70%,
			rgb(255, 255, 255) 95%
		);
		-webkit-background-clip: text;
		color: transparent;
		background-clip: text;
	}

	.content-description {
		font-family: DM Sans;
		font-size: 18px;
		font-weight: 400;
		line-height: 27px;
		letter-spacing: 0px;
		text-align: center;
	}

	@include breakpoint(md) {
		display: flex;
		flex-direction: row;
		gap: 64px;

		.content-title {
			font-size: 54px;
			text-align: left;
		}

		.content-description {
			text-align: left;
		}
	}
}

.divisor {
	margin: 28px 0;
	border-top: 1px solid rgba(255, 255, 255, 0.2);

	@include breakpoint(md) {
		margin: 56px 0;
	}
}

.trader-authors-container {
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	&:last-child {
		border-bottom: unset;
	}
}
</style>
